import { create } from "zustand";
// import { persist } from "zustand/middleware"; // Remove persist
import { dbHelpers } from "../lib/db";
import { Track } from "../types";
import { useLocalLibraryStore } from "./localLibraryStore";

interface RecentlyPlayedState {
  initialized: boolean;
  recentTracks: Track[];
  initialize: () => Promise<void>;
  addRecentTrack: (track: Track) => void;
  getRecentTracks: (limit?: number) => Track[];
  clearRecentTracks: () => void;
}

export const useRecentlyPlayedStore = create<RecentlyPlayedState>((set, get) => ({
  initialized: false,
  recentTracks: [],

  initialize: async () => {
    if (get().initialized) return;

    try {
      const tracks = await dbHelpers.getRecentlyPlayed();
      set({ recentTracks: tracks, initialized: true });
    } catch (error) {
      console.error("Error initializing recently played store:", error);
      set({ initialized: true });
    }
  },

  addRecentTrack: (track) => {
    useLocalLibraryStore.getState().addToRecentlyPlayed(track);
  },

  getRecentTracks: (limit = 20) => {
    return useLocalLibraryStore.getState().getRecentlyPlayed().slice(0, limit);
  },

  clearRecentTracks: () => {
    useLocalLibraryStore.getState().clearRecentlyPlayed();
  },
}));

// Initialize the store
useRecentlyPlayedStore.getState().initialize();

// Subscribe to changes and persist to IndexedDB
useRecentlyPlayedStore.subscribe((state) => {
  if (state.initialized) {
    state.recentTracks.forEach((track) => {
      dbHelpers.addRecentlyPlayed(track).catch(console.error);
    });
  }
});
